import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
    CreateInclusiveExclusiveEntryDto,
    CreateInclusiveExclusiveTemplateDto,
    InclusiveExclusiveEntryDto,
    InclusiveExclusiveTemplateDto,
    UpdateInclusiveExclusiveEntryDto,
    UpdateInclusiveExclusiveTemplateDto
} from '@travel-planner/library-travel-planner-api';
import { ApiError } from '../../../../core/models/api-error';
import { NavigationDescription } from '../../../../core/models/navigation-description';

export type InclusiveExclusiveListType = 'inclusive' | 'exclusive';

export const InclusiveExclusiveActions = createActionGroup({
    source: 'InclusiveExclusive',
    events: {
        'Load Entries': props<{ searchTerm: string; includeTotal?: boolean }>(),
        'Load Entries Success': props<{ entries: InclusiveExclusiveEntryDto[]; total?: number | undefined }>(),
        'Load Entries Failure': props<{ error: ApiError }>(),

        'Create Entry': props<{
            entry: CreateInclusiveExclusiveEntryDto;
            addToTemplate?: { templateId: number; listType: InclusiveExclusiveListType };
            addToInquiryVariant?: { inquiryVariantId: number; listType: InclusiveExclusiveListType };
        }>(),
        'Create Entry Success': props<{
            entry: InclusiveExclusiveEntryDto;
            addToTemplate?: { templateId: number; listType: InclusiveExclusiveListType };
            addToInquiryVariant?: { inquiryVariantId: number; listType: InclusiveExclusiveListType };
        }>(),
        'Create Entry Failure': props<{ error: ApiError }>(),

        'Update Entry': props<{ id: number; entry: UpdateInclusiveExclusiveEntryDto }>(),
        'Update Entry Success': props<{ entry: InclusiveExclusiveEntryDto }>(),
        'Update Entry Failure': props<{ id: number; error: ApiError }>(),

        'Delete Entry': props<{ id: number }>(),
        'Delete Entry Success': props<{ id: number }>(),
        'Delete Entry Failure': props<{ id: number; error: ApiError }>(),

        'Load Templates': emptyProps(),
        'Load Templates Success': props<{ templates: InclusiveExclusiveTemplateDto[] }>(),
        'Load Templates Failure': props<{ error: ApiError }>(),

        'Create Template': props<{ template: CreateInclusiveExclusiveTemplateDto; navigateOnSuccess?: NavigationDescription }>(),
        'Create Template Success': props<{ template: InclusiveExclusiveTemplateDto; navigateOnSuccess?: NavigationDescription }>(),
        'Create Template Failure': props<{ error: ApiError }>(),

        'Update Template': props<{ id: number; template: UpdateInclusiveExclusiveTemplateDto }>(),
        'Update Template Success': props<{ template: InclusiveExclusiveTemplateDto }>(),
        'Update Template Failure': props<{ id: number; error: ApiError }>(),

        'Delete Template': props<{ id: number; navigateOnSuccess?: NavigationDescription }>(),
        'Delete Template Success': props<{ id: number; navigateOnSuccess?: NavigationDescription }>(),
        'Delete Template Failure': props<{ id: number; error: ApiError }>(),
    }
});
